export default "/institutions/vale-alimentacao.svg";